import * as React from "react";
import { SVGProps, memo } from "react";

const SvgWarn = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={40} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.797 32.188 20 6.938l14.203 25.25H5.797ZM22.45 4.92c-1.075-1.912-3.827-1.912-4.902 0L2.81 31.12c-1.054 1.875.3 4.192 2.451 4.192h29.476c2.15 0 3.506-2.317 2.451-4.192l-14.738-26.2Zm-2.45 8.83c.862 0 1.562.699 1.562 1.562v6.875a1.562 1.562 0 1 1-3.125 0v-6.875c0-.863.7-1.563 1.562-1.563Zm1.874 14.062a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z"
      fill="#B84900"
    />
  </svg>
);

const Memo = memo(SvgWarn);

export default Memo;
